// @flow

import { useCallback } from 'react';

import { useUserInputValues } from './context-use';
import { type UserInputName } from '../user-input';

export function useUserInputValue<V>(name: UserInputName): [V, (V) => void] {
  const [userInputValues, setUserInputValue] = useUserInputValues();

  const value = userInputValues[name];
  const setValue = useCallback(
    (newValue: V) => setUserInputValue(name, newValue),
    [name, setUserInputValue],
  );

  return [value, setValue];
}
